import { gql } from "graphql-tag"

const socials = gql`
  type SocialsAiInstruction {
    content: String!
    createdAt: String!
    description: String
    id: ID!
    identifier: String!
    name: String!
    order: Int!
    tags: [String!]
    updatedAt: String!
  }

  input SocialsAiInstructionUpdateInput {
    content: String
    description: String
    id: ID!
    identifier: String
    name: String
    order: Int
    tags: [String!]
  }

  type SocialsAiInstructionUpdateResponse {
    id: ID!
  }

  input SocialsAiInstructionAddInput {
    content: String!
    description: String
    identifier: String!
    name: String!
    order: Int!
    tags: [String!]
  }

  type SocialsAiInstructionAddResponse {
    id: ID!
  }

  type SocialsAiInstructionDeleteResponse {
    status: String!
  }

  input SocialsAuthorAddInput {
    displayName: String!
    externalId: ID!
    platformId: ID!
    username: String!
  }

  type SocialsAuthorAddResponse {
    createdAt: String!
    displayName: String!
    externalId: ID!
    id: ID!
    platformId: ID!
    updatedAt: String!
    username: String!
  }

  input SocialsAiInstructionsGetInput {
    limit: Int
    sortBy: String
  }

  input SocialsGeneratePostsInput {
    "Additional Instructions"
    additionalInstructions: String
    "Platform Names"
    platformNames: [String!]!
    "Text"
    text: String!
  }

  type GeneratePost {
    platformName: String!
    text: String!
  }

  type SocialsGeneratePostsResponse {
    posts: [GeneratePost!]!
  }

  input SocialsPlatformAddInput {
    apiVersion: String
    description: String
    maxCharactersPerPost: Int!
    name: String!
    serviceName: String!
    targetCharactersPerPost: Int!
    url: String!
  }

  type SocialsPlatform {
    apiVersion: String
    createdAt: String!
    description: String
    id: ID!
    maxCharactersPerPost: Int!
    name: String!
    serviceName: String!
    targetCharactersPerPost: Int!
    updatedAt: String!
    url: String
  }

  input SocialsPlatformGatherPostsInput {
    "Author Id"
    authorId: String!
    "Limit"
    limit: Int
    "Platform Service Name"
    serviceName: String!
  }

  type SocialsPlatformGatherPostsResponse {
    "Added Count"
    count: Int!
  }

  input SocialsPlatformsGetInput {
    limit: Int
    sortBy: String
  }

  input SocialsPostAddInput {
    authorId: ID!
    externalId: ID!
    likeCount: Int
    platformId: ID!
    postedAt: String!
    quoteCount: Int
    replyCount: Int
    repostCount: Int
    text: String
    url: String!
  }

  input SocialsPostsAddInput {
    posts: [SocialsPostAddInput!]!
  }

  type SocialsPostsAddResponse {
    ids: [ID!]!
  }

  type SocialLinks {
    blueSky: String
    createdAt: String!
    facebook: String
    id: ID!
    instagram: String
    reddit: String
    threads: String
    twitterX: String
    updatedAt: String!
    website: String
    youtube: String
  }

  input SocialLinksAddInput {
    blueSky: String
    facebook: String
    instagram: String
    reddit: String
    threads: String
    twitterX: String
    website: String
    youtube: String
  }

  input SocialLinksUpdateInput {
    blueSky: String
    facebook: String
    instagram: String
    reddit: String
    threads: String
    twitterX: String
    website: String
    youtube: String
  }

  enum SocialsHandleRelationshipState {
    FOLLOWER
    FOLLOWING
    MUTUAL
    NONE
  }

  type SocialsHandle {
    id: ID!
    accountId: ID!
    did: String!
    handle: String!
    displayName: String
    avatarUrl: String
    description: String

    followerCount: Int!
    followingCount: Int!
    followsYou: Boolean!
    youFollow: Boolean!
    isMutual: Boolean!
    relationshipState: SocialsHandleRelationshipState!

    followBackRatio: Float!
    score: Float!
    topicScore: Float!

    outboundAmplification: Float!
    outboundReshareRate: Float!
    topicTags: [String!]!
    lastPostAt: String
    latestInteractedAt: String
    lastSyncedAt: String
    lastScoredAt: String

    notes: String
    isIgnored: Boolean!
    manualPriority: Float!

    createdAt: String!
    updatedAt: String!
  }

  type SocialsHandlesWave {
    cursor: String
    prevCursor: String
    hasNextData: Boolean!
    hasPrevData: Boolean
    handles: [SocialsHandle!]!
  }

  type SocialsProspectDefaults {
    defaultKeywords: [String!]!
  }

  input GetWaveQuerySocialsHandles {
    accountId: ID!
    cursor: String
    limit: Int

    relationshipState: SocialsHandleRelationshipState
    followsYou: Boolean
    topicTags: [String!]
    recencyDays: Int
    accountCreatedSinceDays: Int
    latestInteractedDaysMin: Int

    scoreMin: Float
    scoreMax: Float
    followBackRatioMin: Float
    followBackRatioMax: Float
    followerCountMin: Int
    followingCountMin: Int
    outboundAmplificationMin: Float
    outboundAmplificationMax: Float
    outboundReshareRateMin: Float
    outboundReshareRateMax: Float

    isIgnored: Boolean
  }

  input SocialsHandleUpdateInput {
    id: ID!
    accountId: ID!
    notes: String
    isIgnored: Boolean
    manualPriority: Float
    latestInteractedAt: String
  }

  """
  Input for running a Socials job (always account-scoped).
  """
  input SocialsJobRunInput {
    "UUIDv4 accountId."
    accountId: ID!

    "Optional override keywords for discovery ingest."
    keywordsOverride: [String!]
  }

  type SocialsJobRunResponse {
    status: String!
    message: String
    jobId: ID
    runId: ID
  }
`

export default socials
